import React from "react";
import styles from "./SourceInfo.module.scss";

export const SourceInfo = ({ source, webUrl }) => {
  if (!source && !webUrl) return null;
  return (
    <div className={styles.wrap}>
      {source && <div className={styles.source}>Source: {source}</div>}
      {webUrl && (
        <a className={styles.link} href={webUrl} target="_blank" rel="noreferrer">
          {webUrl}
        </a>
      )}
    </div>
  );
};
